(function($){


	$.fn.chanInstagram = function(options){

		var $elements = $(this);

		var params = {
			access_token: options.access_token,
			count: Math.min(20,$elements.length)
		};

		var url = 'https://api.instagram.com/v1/users/' + options.userid + '/media/recent?callback=?&' + $.param(params);

		var imageSuccess = function(i,data){

			if(!$elements[i]) return;

			var res = {
				url: data.link || 'javascript:;', // jshint ignore:line
				image: data.images.standard_resolution.url,
				likes: data.likes.count,
				comments: data.comments.count,
				caption: data.caption ? (data.caption.text||'') :'',
				time: data.created_time * 1000
			};

			if (options.success && options.success.call($elements[i],res,i,data));

		};

		var instagramError = function(){
			if (options.error && options.error.apply($elements,arguments));
		};

		var resHandle = function(r){
			if(r && r.data){
				for (var i = 0; i < r.data.length; i++) imageSuccess(i,r.data[i]);
				//options.complete && options.complete.call($elements,r);
			}else{
				instagramError(r);
			}
		};

		params.count ? $.getJSON(url,resHandle).fail(instagramError) : instagramError(); // jshint ignore:line

	};


	/*
	 * timeAgo
	 * http://ejohn.org/blog/javascript-pretty-date/#comment-297458
	 */
	$.fn.chanInstagram.timeAgo = function(dateStr){
		var timeFormats = [
			[60, 'seconds', 1],
			[120, '1 minute ago'],
			[3600, 'minutes', 60],
			[7200, '1 hour ago'],
			[86400, 'hours', 3600],
			[172800, 'Yesterday'],
			[604800, 'days', 86400],
			[1209600, '1 week ago'],
			[2678400, 'weeks', 604800]
		];
		var time = ('' + dateStr).replace(/-/g,"/").replace(/[TZ]/g," ");
		var seconds = (new Date() - new Date(time*1)) / 1000;
		var i = 0, format;
		while (format = timeFormats[i++]) if (seconds < format[0]) // jshint ignore:line
		return format[2] ? Math.floor(seconds / format[2]) + ' ' + format[1] + ' ago' :  format[1];
		return false;//time;
	};

})(jQuery);